import React from "react";
import ScrollRevealText from "../Comman/ScrollRevealText";

export default function BuySuperElite() {
  return (
    <>
      <div className="tp-service-area  pb-130 tp-btn-trigger">
        <div className="container ">
          {/* container-1630 */}
          <div className=" justify-content-center">
            <div className=" ">
              <div className="tp-about-2-title-box tp-btn-trigger tp-btn-bounce mb-70 text-start text-xl-center">
                <ScrollRevealText text="Buy Kryptogram Super Elite NFT" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-5 col-lg-5">
              <div className="text-center">
                <img
                  src="assets/img/one/super_elite.png"
                  style={{ height: "530px" }}
                />
              </div>
              <div className="tp-service-left-btn tp-btn-bounce text-center pt-5 mt-5">
                {/* <a className="tp-btn-border" href="/buy-nft">
                  <span className="tp-btn-border-wrap">
                    <span className="text-1">Buy NFTs</span>
                    <span className="text-2">Buy NFTs</span>
                  </span>
                </a> */}
                <a className="tp-btn-black-2" href="/buy-nft">
                  Buy NFTs
                  <span className="p-relative">
                    <svg
                      className="svg-icon"
                      width={10}
                      height={10}
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.86041 4.6429C9.94985 4.7377 10 4.86575 10 4.9992C10 5.13264 9.94985 5.2607 9.86041 5.35551L5.57586 9.85624C5.48448 9.94804 5.36309 9.99948 5.23667 10C5.17349 9.99969 5.11092 9.98704 5.0522 9.96246C4.96556 9.9243 4.89163 9.85991 4.83974 9.77759C4.78785 9.69527 4.76032 9.59866 4.76061 9.49994V5.49928H0.476061C0.349802 5.49928 0.228714 5.4466 0.139435 5.35281C0.0501564 5.25903 0 5.13183 0 4.9992C0 4.86657 0.0501564 4.73937 0.139435 4.64559C0.228714 4.55181 0.349802 4.49912 0.476061 4.49912H4.76061V0.49847C4.76032 0.399742 4.78785 0.303131 4.83974 0.220813C4.89163 0.138494 4.96556 0.0741515 5.0522 0.0358946C5.14013 -0.000133693 5.23598 -0.00927405 5.32865 0.00953239C5.42132 0.0283378 5.50703 0.0743215 5.57586 0.142163L9.86041 4.6429Z"
                        fill="currentcolor"
                      />
                    </svg>
                    <svg
                      className="svg-bg"
                      width={30}
                      height={30}
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.2257 0.947522C14.6258 0.457905 15.3742 0.457905 15.7743 0.947522L16.8781 2.29817C17.181 2.66879 17.704 2.77283 18.1256 2.54633L19.6623 1.72088C20.2193 1.42165 20.9107 1.70806 21.093 2.31352L21.5959 3.98376C21.7339 4.44207 22.1773 4.73834 22.6535 4.69044L24.3891 4.51587C25.0182 4.45258 25.5474 4.98179 25.4841 5.61093L25.3096 7.34647C25.2617 7.8227 25.5579 8.2661 26.0162 8.40409L27.6865 8.90697C28.2919 9.08926 28.5783 9.7807 28.2791 10.3377L27.4537 11.8744C27.2272 12.296 27.3312 12.819 27.7018 13.1219L29.0525 14.2257C29.5421 14.6258 29.5421 15.3742 29.0525 15.7743L27.7018 16.8781C27.3312 17.181 27.2272 17.704 27.4537 18.1256L28.2791 19.6623C28.5783 20.2193 28.2919 20.9107 27.6865 21.093L26.0162 21.5959C25.5579 21.7339 25.2617 22.1773 25.3096 22.6535L25.4841 24.3891C25.5474 25.0182 25.0182 25.5474 24.3891 25.4841L22.6535 25.3096C22.1773 25.2617 21.7339 25.5579 21.5959 26.0162L21.093 27.6865C20.9107 28.2919 20.2193 28.5783 19.6623 28.2791L18.1256 27.4537C17.704 27.2272 17.181 27.3312 16.8781 27.7018L15.7743 29.0525C15.3742 29.5421 14.6258 29.5421 14.2257 29.0525L13.1219 27.7018C12.819 27.3312 12.296 27.2272 11.8744 27.4537L10.3377 28.2791C9.7807 28.5783 9.08926 28.2919 8.90697 27.6865L8.40409 26.0162C8.2661 25.5579 7.8227 25.2617 7.34647 25.3096L5.61093 25.4841C4.98179 25.5474 4.45258 25.0182 4.51587 24.3891L4.69044 22.6535C4.73834 22.1773 4.44207 21.7339 3.98376 21.5959L2.31352 21.093C1.70806 20.9107 1.42165 20.2193 1.72088 19.6623L2.54633 18.1256C2.77283 17.704 2.66879 17.181 2.29817 16.8781L0.947522 15.7743C0.457905 15.3742 0.457905 14.6258 0.947522 14.2257L2.29817 13.1219C2.66879 12.819 2.77283 12.296 2.54633 11.8744L1.72088 10.3377C1.42165 9.7807 1.70806 9.08926 2.31352 8.90697L3.98376 8.40409C4.44207 8.2661 4.73834 7.8227 4.69044 7.34647L4.51587 5.61093C4.45258 4.98179 4.98179 4.45258 5.61093 4.51587L7.34647 4.69044C7.8227 4.73834 8.2661 4.44207 8.40409 3.98376L8.90697 2.31352C9.08926 1.70806 9.7807 1.42165 10.3377 1.72088L11.8744 2.54633C12.296 2.77283 12.819 2.66879 13.1219 2.29817L14.2257 0.947522Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </a>
              </div>
            </div>
            <div className="col-xl-7 col-lg-7">
              <div className="tp-service-right-wrap">
                <h3 className="text-white pb-4">
                  What You Get with a Kryptogram SuperElite NFT
                </h3>
                <div className="tp-service-item d-flex align-items-start mb-30 tp_fade_bottom">
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm text-yellow-new order-0">
                      <a>VIP Festival Access</a>
                    </h4>
                    <p className="order-1">
                      Enjoy Super-Elite Lounge at all Tribe O Crypto
                      performances and exclusive access to premium festival
                      areas. Xeer Technology, Today at 1:14 PM
                    </p>
                  </div>
                </div>
                <div className="tp-service-item d-flex align-items-start mb-30 tp_fade_bottom">
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm text-yellow-new">
                      <a>Luxury Arrival & Departure</a>
                    </h4>
                    <p>
                      Personalized helicopter transfers for seamless VIP entry.
                      🥂 Exclusive Lounges & Concierge Services: Gain access to
                      ultra-luxury private lounges with premium hospitality.
                    </p>
                  </div>
                </div>
                <div className="tp-service-item d-flex align-items-start mb-30 tp_fade_bottom">
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm text-yellow-new">
                      <a>Personalized Festival Experience</a>
                    </h4>
                    <p>
                      Priority access to networking sessions, meet-and-greets,
                      and private crypto investor gatherings.
                    </p>
                  </div>
                </div>
                <div className="tp-service-item d-flex align-items-start mb-30 tp_fade_bottom">
                  <div className="tp-service-content">
                    <h4 className="tp-service-title-sm text-yellow-new">
                      <a>Ultra-Rare Collectible</a>
                    </h4>
                    <p>
                      With only 200 Kryptogram SuperElite NFTs available, owning
                      one means being part of an exclusive elite network.
                    </p>
                  </div>
                </div>
                {/* <div className="tp-shop-details-price">
                  <span>200 Kryptogram SuperElite NFTs</span>
                </div>
                <div className="tp-shop-details-price pt-2">
                  <span>$25000</span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
